import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
declare var google;
import * as moment from 'moment';
import Swal from 'sweetalert2';
import { FirestoreService } from 'src/app/services/service.index';
import { Router, ActivatedRoute } from '@angular/router';
import { concat } from 'rxjs/operators';
@Component({
  selector: 'app-editorder',
  templateUrl: './editorder.component.html',
  styleUrls: ['./editorder.component.css']
})
export class EditorderComponent implements OnInit {

  user:any;

  productLat: number;
  productLong: number;
  marker: any;
  map: any;

  userLat:any;
  userLng:any;

  latDes:any;
  lngDes:any;

  directionsDisplay:any;
  directionsService:any;
  polyline:any;
  markers:any = [];

  distance:any;
  time:any;
  address1:any;
  address2:any;

  total:any;

  icons = {
    start: new google.maps.MarkerImage(
    // URL
    '../assets/img/punto_start.png',
    // (width,height)
    new google.maps.Size( 64, 64 ),
    // The origin point (x,y)
    new google.maps.Point( 0, 0 ),
    // The anchor point (x,y)
    new google.maps.Point( 27, 46 )
    ),
    end: new google.maps.MarkerImage(
    // URL
    '../assets/img/punto_end.png',
    // (width,height)
    new google.maps.Size( 64, 64 ),
    // The origin point (x,y)
    new google.maps.Point( 0, 0 ),
    // The anchor point (x,y)
    new google.maps.Point( 27,46)
    )
    };

  @ViewChild('mapContainer', { static: false }) gmap: ElementRef;

  customers:any = [];

  mapOptions:any;

  date: string;

  dateExample:any;

  selectedStatus = "0";


  forma = new FormGroup({
    id: new FormControl(),
    companyname: new FormControl( null, Validators.required),
    firstnamecontact: new FormControl( null, Validators.required),
    lastnamecontact: new FormControl(),
    idcustomer: new FormControl(),
    datedelivery: new FormControl(),
    phone: new FormControl(),
    total: new FormControl(),
    distance: new FormControl(),
    time: new FormControl(),
    status: new FormControl(),
    address: new FormControl(),
    description: new FormControl(" "),
    hourdeliveryfrom: new FormControl(),
    hourdeliveryto: new FormControl(),
    latitude:  new FormControl(0),
    longitude: new FormControl(0),
    selected:  new FormControl('valid', [
      Validators.required,
      Validators.pattern('valid'),
    ]),
  });



  constructor(private afs: FirestoreService, private router: Router, private activatedRoute: ActivatedRoute) {
    this.directionsService  = new google.maps.DirectionsService();
    this.date = moment().format('DD/MM/YYYY'); //for date-picker
  }

  ngOnInit(): void {

    this.user = this.afs.usersShow;

    this.loadCustomer();

    this.activatedRoute.params.subscribe(params => {

      //console.log(params.id);

      this.afs.getOrderPro(this.user.companyId, params.id).then((order:any) => {

          let orders = order.data();

          this.initValueForm(orders);

          this.mapInitializer(orders.latitude, orders.longitude);

      });

    });


  }

  loadCustomer(){
    this.afs.getAllCustomerPro(this.user.companyId).then(res =>{

      res.forEach(doc =>{


          this.customers.push(doc.data());

      });

    }).catch(err => {
      console.log(err);
    })
  }


  initValueForm(order: any){



     this.forma.patchValue({
      id: order.id,
      companyname: order.companyname,
      selected: order.selected,
      firstnamecontact: order.firstnamecontact,
      lastnamecontact: order.lastnamecontact,
      idcustomer: order.idcustomer,
      datedelivery: new Date(order.datedelivery),
      phone: order.phone,
      total: order.total,
      distance: order.distance,
      time: order.time,
      status: String(order.status),
      address: order.address,
      description: order.description,
      hourdeliveryfrom: order.hourdeliveryfrom,
      hourdeliveryto: order.hourdeliveryto,
      latitude:   order.latitude,
      longitude: order.longitude
     });


   }

  editOrder(){


       this.forma.value.distance = this.distance;
       this.forma.value.time = this.time;
       this.forma.value.total = this.total;
       this.forma.value.orderCreated =  new Date().getTime();
       this.forma.value.datedelivery =  new Date(this.forma.value.datedelivery).getTime()


      this.afs.updateOrder(this.user.companyId, this.forma.value.id, this.forma.value).then(res => {


          this.router.navigate(['/orders']);

            Swal.fire('Good job!','Create Order ha been edited Successful!!!','success');

      }).catch(err => {


         Swal.fire('Oops...', 'Order has not been edited! ' + err, 'error');

      });

  }


  mapInitializer(lat:any, lng: any) {

    navigator.geolocation.getCurrentPosition((position) => {
    // place your product lat or longtitude here
    this.productLat = position.coords.latitude;// change it to your preferences
    this.productLong = position.coords.longitude; // <-- static


    let originMarker = new google.maps.LatLng( this.productLat, this.productLong);
    let destinyMarker = new google.maps.LatLng( lat, lng );

    const coordinates = new google.maps.LatLng(this.productLat, this.productLong); // init our coordinate for marker :)
    /*this.marker = new google.maps.Marker({
      position: coordinates,
      map: this.map
    })*/
    // check here to get to know about map options docs
    this.mapOptions = google.maps.MapOptions = {
    // here to place centering our location based on coordinates
    center: coordinates,
    zoom: 18,
    fullscreenControl: false,
    mapTypeControl: false,
    streetViewControl: false
    };
    //set our lovely google maps here and marker here
    this.map = new google.maps.Map(this.gmap.nativeElement, this.mapOptions);

    //this.marker.setMap(this.map);


       this.directionsDisplay = new google.maps.DirectionsRenderer({ polylineOptions: { strokeColor: "#FF364F", strokeOpacity: 0.8, strokeWeight: 5,  geodesic: true }, suppressMarkers: true, map: this.map} );

          this.viewRoute(originMarker, destinyMarker);

    })
   }


    setMapOnAll(map) {
      for (var i = 0; i < this.markers.length; i++) {
        this.markers[i].setMap(map);
      }
     }


    clearMarkers() {
      this.setMapOnAll(null);
    }

     deleteMarkers() {
      this.clearMarkers();
      this.markers = [];
    }


    viewRoute(origen, destino){


      this.deleteMarkers();

      this.directionsService.route({
      origin: origen,
      destination: destino,
      travelMode: google.maps.TravelMode.DRIVING,
      //avoidTolls: true
      }, (response, status)=> {

      if(status === google.maps.DirectionsStatus.OK) {



              var route = response.routes[0];
              var r = response.routes[0].legs[0];

              //console.log(r);

              /*this.start_address = r.start_address;
              this.end_address = r.end_address;*/

              this.distance = r.distance.text;
              this.time = r.duration.text;

              let costo_viaje = 1000;
              let calculo= parseFloat(r.distance.text);

              this.total = Math.round(costo_viaje * calculo);

              this.address1 =  r.start_address;
              this.address2 = r.end_address;


              this.makeMarker( r.start_location, this.icons.start, r.start_address, 0);
              this.makeMarker( r.end_location, this.icons.end, r.end_address, 1);


              const points = new Array<any>();
              const routes = response.routes[0].overview_path;


              for(let i=0; i< routes.length; i++){
                  points[i]= {
                      lat: routes[i].lat(),
                      lng: routes[i].lng()
                  }
              }




                this.polyline = new google.maps.Polyline({
                  map: this.map,
                  path: points,
                  strokeColor: '#FF364F',
                  strokeOpacity: 0.9,
                  strokeWeight: 4,
                  geodesic: true
                });



            this.map.fitBounds(response.routes[0].bounds);
            this.map.setZoom(14);
            this.directionsDisplay.setDirections(response);



      }else{
        alert('Could not display directions due to: ' + status);
      }
      });


    }

      //makeMaker
  makeMarker(position, icon, title, order) {

    this.marker = new google.maps.Marker({
      map: this.map,
      icon:icon,
      animation: google.maps.Animation.DROP,
      position: position
    });

    if(order == 0 ){
      //this.addInfoCarga(this.marker, title);
      this.markers.push(this.marker);
    }else if(order==1){
      //this.addInfoDescarga(this.marker, title);
      this.markers.push(this.marker);
    }else{
      this.markers.push(this.marker);
    }

}

selectCustomer(cus){
  console.log(cus.value);
  let id = cus.value;

  this.afs.getCustomerByCompany(this.user.companyId, id).subscribe(res => {

      console.log(res);

      this.forma.controls['companyname'].setValue(res.companyname);

      this.forma.controls['idcustomer'].setValue(res.id);

      this.forma.controls['firstnamecontact'].setValue(res.firstnamecontact);

      this.forma.controls['lastnamecontact'].setValue(res.lastnamecontact);

      this.forma.controls['address'].setValue(res.address);

      this.forma.controls['phone'].setValue(res.phone);


     // this.getDirection(res.latitude, res.longitude);


  });

}

}
